import { RootState } from "@store";
import { useSelector } from "react-redux";

export const useMinerProfiles = () => {
  return useSelector((state: RootState) => state.minerProfiles.profiles);
};
